// Данные страницы от сервера (render_page в pravosvod/web/app.py).
import { setLoadedVersion } from "./lib/version";
import type { ChatBrief, SavedItem, UploadedDoc, Folder } from "./store";

export type PreviewPart = { text: string; bold?: boolean; field?: string; label?: string; auto?: boolean };
export type Paragraph = { align: string; indent?: boolean; parts: PreviewPart[] };

export type TemplateBrief = {
  slug: string; title: string; short_title: string; law: string; question_count: number; match: string;
};

export type Page = "chat" | "documents" | "my" | "privacy" | "auth_problem" | "dashboard" | "settings" | "admin";

export type Boot = {
  page: Page;
  version: string;
  path: string;
  user: { name: string; email: string } | null;
  isGuest: boolean;
  isAdmin: boolean;                        // кабинет администратора /admin (pravosvod/admin.py)
  adminPassword: boolean;                  // в кабинет можно войти логином и паролем
  adminSession: boolean;                   // вошли в кабинет логином и паролем — есть «Выйти из кабинета»
  aiEnabled: boolean;
  loginOptions: { slug: string; title: string; enabled: boolean }[];
  emailLogin: boolean;
  templates: TemplateBrief[];
  previews: Record<string, Paragraph[]>;
  soonDocuments: [string, string][];
  message: string;
  lists: { saved: { doc: SavedItem[]; calc: SavedItem[] }; documents: UploadedDoc[]; chats: ChatBrief[]; folders: Folder[] } | null;
};

export const boot: Boot = JSON.parse(document.getElementById("bootstrap")!.textContent!);
setLoadedVersion(boot.version);                      // с этой версией открылась вкладка (lib/version.ts)
export const MARK_URL = `/static/brand/mark-64.png?v=${boot.version}`;
